import { useCallback } from "react";

interface FetchFunction {
  (params: { transactionId: string }): Promise<{ url: string }>;
}

const useAsanAdocDownloader = () => {
  const downloadAdocFile = useCallback(
    async (fetchFunction: FetchFunction, transactionId: string, fileName: string = "downloaded_file.adoc") => {
      try {
        const { url: data } = await fetchFunction({ transactionId });

        const [metadata, base64String] = data.split(",");

        const mimeTypeMatch = metadata.match(/data:(.*);base64/);
        if (!mimeTypeMatch) {
          throw new Error("Invalid base64 data format");
        }

        const mimeType = mimeTypeMatch[1];
        const byteCharacters = atob(base64String);
        const byteNumbers = new Uint8Array(new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i))
        );

        const fileBlob = new Blob([byteNumbers], { type: mimeType });

        const url = URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("🚀 ~ useFileDownloader ~ error:", error);
      }
    },
    []
  );

  return { downloadAdocFile };
};

export default useAsanAdocDownloader;
